<template>
    <div v-if="props.dist.AgeOfDataValue != 0" class="absolute bottom-[3px] left-0 m-0 inline-block">
        <span :class="cssClass" :title="tooltip">
            <i class="fas fa-clock" />
            {{ label }}
        </span>
    </div>
</template>

<script setup>
const { t } = useI18n();

const AGE_INCREMENTS = {
    0: {
        name: "RealTime",
        singular: "Global.RealTime",
        plural: "Global.RealTime",
    },
    1: {
        name: "Seconds",
        singular: "Global.Second",
        plural: "Global.Seconds",
    },
    2: {
        name: "Minutes",
        singular: "Global.Minute",
        plural: "Global.Minutes",
    },
    3: {
        name: "Hours",
        singular: "Global.Hour",
        plural: "Global.Hours",
    },
    4: {
        name: "Days",
        singular: "Global.Day",
        plural: "Global.Days",
    },
};

const props = defineProps({
    dist: { type: Object, required: true },
});

const cssClass = computed(() => {
    const baseClass = "uppercase font-bold text-xs whitespace-nowrap px-2 py-1";
    switch (AGE_INCREMENTS[props.dist.AgeOfDataIncrement].name) {
        case "RealTime":
            return `${baseClass} bg-success-200 text-success-800`;

        case "Seconds":
            return `${baseClass} bg-info-100 text-info-700`;

        case "Minutes":
            return `${baseClass} bg-info-100 text-info-700`;

        case "Hours":
            return `${baseClass} bg-info-100 text-info-700`;

        case "Days":
            return `${baseClass} bg-warning-100 text-warning-700`;

        default:
            return `${baseClass} bg-gray-200 text-black`;
    }
});

const label = computed(() => {
    if (props.dist.AgeOfDataValue == 1) {
        return t(AGE_INCREMENTS[props.dist.AgeOfDataIncrement].singular, [props.dist.AgeOfDataValue]);
    } else {
        return t(AGE_INCREMENTS[props.dist.AgeOfDataIncrement].plural, [props.dist.AgeOfDataValue]);
    }
});

const tooltip = computed(() => {
    if (AGE_INCREMENTS[props.dist.AgeOfDataIncrement].name == "RealTime") {
        return t("Global.RealTimeTooltip");
    } else {
        return t("Global.AgeTooltip", [label.value.toLowerCase()]);
    }
});
</script>
